// All current connection schemes supported by App Framework
export var CONNECTION_SCHEMES = Object.freeze({
    API_KEY: 'apikey',
    BASIC: 'basic',
    OAUTH: 'oauth2',
    SFTP: 'sftp',
    ADOBE: 'adobe',
    EPIC: 'epic',
    OAUTH_CLIENT_JWT: 'oauth2ClientJWT',
    AWSSIGV4: 'awsSigV4',
    // NOTE: The successfactors scheme is NOT recognized by the credential service. It
    // instead uses the oauth2ClientSAML scheme under the hood.
    SUCCESS_FACTORS: 'successfactors',
    // NOTE: The internal scheme is NOT recognized by the credential service. It
    // is only for use by first-party apps, to access UDS endpoints.
    // See APP-1290.
    INTERNAL: 'internal',
    // NOTE: The none scheme is NOT recognized by the credential service. It
    // instead uses the mtls scheme under the hood.
    NONE: 'none',
});
//# sourceMappingURL=constants.js.map